<template>
  <pixel-spinner
    :animation-duration="2000"
    :size="70"
    color="#be403e"
    class="spinner"
  />
</template>

<script>
import { PixelSpinner } from 'epic-spinners'
export default {
  name: 'Spinner',
  components: {
    PixelSpinner
  }
}
</script>
<style>
  .spinner {
    position: fixed !important;
    top: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh !important;
    width: 100% !important;
    z-index: 10000 !important;
    background: rgba(255, 255, 255, 0.9) !important;
  }

  .pixel-spinner .spinner-inner {
    position: relative;
    display: block;
    height: 70px!important;
    width: 70px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue